if (!window.__opfScriptsLoaded) {
  window.__opfScriptsLoaded = true;

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initTilt();
    initGaleriaProducto();
    initVariantes();
    initCatalogoNav();
    initStickyCart();
  });

  /* ---- Precarga de imágenes en segundo plano (para que el cambio de foto sea instantáneo) --- */
  var __opfImagenesPrecargadas = {};
  function opfUrlAbsoluta(url) {
    try { return new URL(url, window.location.href).href; } catch (e) { return url; }
  }
  function precargarImagenes(urls) {
    if (!urls || !urls.length) return;
    var pendientes = urls.filter(Boolean).map(opfUrlAbsoluta).filter(function (u) { return !__opfImagenesPrecargadas[u]; });
    if (!pendientes.length) return;
    var precargarUna = function () {
      var url = pendientes.shift();
      if (!url) return;
      __opfImagenesPrecargadas[url] = true;
      var img = new Image();
      img.decoding = 'async';
      img.src = url;
      if (pendientes.length) programar(precargarUna);
    };
    var programar = function (fn) {
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(fn, { timeout: 800 });
      } else {
        setTimeout(fn, 60);
      }
    };
    programar(precargarUna);
  }

  /* ---- Reveal on scroll ---------------------------------------------------- */
  function initReveal() {
    var els = document.querySelectorAll('.opf-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('opf-visible'); });
      return;
    }
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry, i) {
          if (entry.isIntersecting) {
            var el = entry.target;
            var delay = parseInt(el.getAttribute('data-opf-delay') || '0', 10);
            setTimeout(function () { el.classList.add('opf-visible'); }, delay);
            observer.unobserve(el);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );
    els.forEach(function (el) { observer.observe(el); });
  }

  /* ---- Ligero tilt de tarjetas al pasar el cursor -------------------------- */
  function initTilt() {
    var els = document.querySelectorAll('.opf-tilt');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (window.matchMedia('(pointer: coarse)').matches) return;
    els.forEach(function (el) {
      el.addEventListener('mousemove', function (e) {
        var rect = el.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        el.style.transform = 'perspective(700px) rotateX(' + (y * -4) + 'deg) rotateY(' + (x * 4) + 'deg) translateY(-4px)';
      });
      el.addEventListener('mouseleave', function () {
        el.style.transform = '';
      });
    });
  }

  /* ---- Galería de producto: miniaturas, flechas y cambio por variante ------ */
  function initGaleriaProducto() {
    var galeria = document.querySelector('[data-opf-galeria]');
    if (!galeria) return;
    var principal = galeria.querySelector('[data-opf-imagen-principal]');
    var miniaturas = Array.prototype.slice.call(galeria.querySelectorAll('[data-opf-miniatura]'));
    var track = galeria.querySelector('[data-opf-miniaturas-track]');
    if (!principal) return;

    __opfImagenesPrecargadas[principal.src] = true;
    precargarImagenes(miniaturas.map(function (b) { return b.getAttribute('data-full'); }));

    var indiceActual = 0;

    function marcarActiva(idx) {
      miniaturas.forEach(function (b, i) {
        b.classList.toggle('opf-activa', i === idx);
      });
      if (miniaturas[idx]) {
        miniaturas[idx].scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }

    function cambiarImagenPrincipal(url, alt) {
      if (!url || opfUrlAbsoluta(url) === principal.src) return;
      var yaCacheada = !!__opfImagenesPrecargadas[opfUrlAbsoluta(url)];
      if (!yaCacheada) principal.classList.add('opf-cambiando');
      principal.src = url;
      if (alt !== undefined) principal.alt = alt || '';
      if (!yaCacheada) {
        var quitar = function () { principal.classList.remove('opf-cambiando'); };
        if (principal.decode) principal.decode().then(quitar).catch(quitar);
        else principal.onload = quitar;
      }
    }

    function mostrarIndice(idx) {
      if (!miniaturas.length) return;
      indiceActual = (idx + miniaturas.length) % miniaturas.length;
      var btn = miniaturas[indiceActual];
      cambiarImagenPrincipal(btn.getAttribute('data-full'), btn.getAttribute('data-alt'));
      marcarActiva(indiceActual);
    }

    function mostrarUrl(url) {
      if (!url) return;
      var idx = -1;
      for (var i = 0; i < miniaturas.length; i++) {
        if (miniaturas[i].getAttribute('data-full') === url) { idx = i; break; }
      }
      if (idx > -1) {
        mostrarIndice(idx);
      } else {
        cambiarImagenPrincipal(url);
      }
    }

    miniaturas.forEach(function (btn, i) {
      btn.addEventListener('click', function () { mostrarIndice(i); });
    });

    galeria.querySelectorAll('[data-opf-flecha]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = btn.getAttribute('data-opf-flecha') === 'next' ? 1 : -1;
        mostrarIndice(indiceActual + dir);
      });
    });

    galeria.querySelectorAll('[data-opf-mini-flecha]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (!track) return;
        var dir = btn.getAttribute('data-opf-mini-flecha') === 'next' ? 1 : -1;
        track.scrollBy({ left: dir * (track.clientWidth * 0.7), behavior: 'smooth' });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      var activo = document.activeElement;
      var tag = activo && activo.tagName;
      if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || (activo && activo.isContentEditable)) return;
      if (miniaturas.length < 2) return;
      mostrarIndice(indiceActual + (e.key === 'ArrowRight' ? 1 : -1));
    });

    window.__opfGaleria = { mostrarUrl: mostrarUrl };
  }

  /* ---- Selector de variantes: actualiza id/precio/stock sin recargar ------- */
  function initVariantes() {
    var opciones = document.querySelector('[data-opf-producto-form]');
    if (!opciones) return;
    var form = opciones.querySelector('form');
    if (!form) return;
    var dataEl = document.querySelector('[data-opf-variantes-json]');
    if (!dataEl) return;

    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var inputId = form.querySelector('input[name="id"]');
    var botones = opciones.querySelectorAll('[data-opf-opcion-valor]');
    var precioActual = document.querySelector('[data-opf-precio-actual]');
    var precioTachado = document.querySelector('[data-opf-precio-tachado]');
    var botonSubmit = form.querySelector('[data-opf-boton-comprar]');
    var estadoStock = document.querySelector('[data-opf-estado-stock]');
    var numOpciones = parseInt(opciones.getAttribute('data-opf-num-opciones') || '1', 10);

    precargarImagenes(variantes.map(function (v) { return v.image; }));

    function seleccionActual() {
      var seleccion = [];
      for (var i = 1; i <= numOpciones; i++) {
        var activo = opciones.querySelector('[data-opf-opcion-index="' + i + '"].opf-seleccionada');
        seleccion.push(activo ? activo.getAttribute('data-opf-opcion-valor') : null);
      }
      return seleccion;
    }

    function encontrarVariante(seleccion) {
      return variantes.find(function (v) {
        return v.options.every(function (opt, idx) { return opt === seleccion[idx]; });
      });
    }

    function formatMoney(cents) {
      var amount = cents / 100;
      var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'es', { style: 'currency', currency: currency }).format(amount);
      } catch (e) {
        return amount.toFixed(2).replace('.', ',') + ' ' + currency;
      }
    }

    function actualizar() {
      var seleccion = seleccionActual();
      var variante = encontrarVariante(seleccion);
      if (!variante) return;

      inputId.value = variante.id;
      if (precioActual) precioActual.textContent = formatMoney(variante.price);
      if (precioTachado) {
        if (variante.compare_at_price && variante.compare_at_price > variante.price) {
          precioTachado.textContent = formatMoney(variante.compare_at_price);
          precioTachado.style.display = '';
        } else {
          precioTachado.style.display = 'none';
        }
      }
      if (variante.image && window.__opfGaleria) window.__opfGaleria.mostrarUrl(variante.image);
      if (botonSubmit) botonSubmit.disabled = !variante.available;
      var stickyPrecio = document.querySelector('[data-opf-sticky-precio]');
      var stickyBoton = document.querySelector('[data-opf-sticky-boton]');
      if (stickyPrecio) stickyPrecio.textContent = formatMoney(variante.price);
      if (stickyBoton) stickyBoton.disabled = !variante.available;
      if (estadoStock) {
        if (variante.available) {
          estadoStock.textContent = estadoStock.getAttribute('data-texto-disponible') || 'En stock';
          estadoStock.className = 'opf-estado-stock opf-disponible';
        } else {
          estadoStock.textContent = estadoStock.getAttribute('data-texto-agotado') || 'Agotado';
          estadoStock.className = 'opf-estado-stock opf-agotado';
        }
      }

      botones.forEach(function (b) {
        var idx = parseInt(b.getAttribute('data-opf-opcion-index'), 10);
        if (b.getAttribute('data-opf-opcion-valor') === seleccion[idx - 1]) {
          b.classList.add('opf-seleccionada');
        }
      });
    }

    botones.forEach(function (b) {
      b.addEventListener('click', function () {
        var idx = b.getAttribute('data-opf-opcion-index');
        opciones.querySelectorAll('[data-opf-opcion-index="' + idx + '"]').forEach(function (o) {
          o.classList.remove('opf-seleccionada');
        });
        b.classList.add('opf-seleccionada');
        actualizar();
      });
    });
  }

  /* ---- Barra de compra fija en móvil ---------------------------------------*/
  function initStickyCart() {
    var sticky = document.querySelector('[data-opf-sticky-cart]');
    if (!sticky) return;
    var formulario = document.querySelector('[data-opf-producto-form] form');
    var botonReal = document.querySelector('[data-opf-boton-comprar]');
    var botonSticky = document.querySelector('[data-opf-sticky-boton]');
    if (!formulario || !botonReal || !botonSticky) return;

    botonSticky.addEventListener('click', function () {
      if (botonSticky.disabled) return;
      botonReal.click();
    });

    var objetivo = document.querySelector('.opf-compra-form');
    if (!objetivo || !('IntersectionObserver' in window)) {
      sticky.hidden = false;
      sticky.classList.add('opf-sticky-cart-visible');
      return;
    }
    sticky.hidden = false;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          sticky.classList.toggle('opf-sticky-cart-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      },
      { threshold: 0 }
    );
    observer.observe(objetivo);
  }

  /* ---- Menú flotante de secciones del catálogo (scroll-spy) ---------------- */
  function initCatalogoNav() {
    var nav = document.querySelector('[data-opf-catnav]');
    if (!nav) return;
    var enlaces = Array.prototype.slice.call(nav.querySelectorAll('[data-opf-catnav-link]'));
    if (!enlaces.length) return;
    var secciones = enlaces
      .map(function (a) { return document.getElementById(a.getAttribute('data-opf-catnav-link')); })
      .filter(Boolean);
    if (!secciones.length) return;

    function activar(id) {
      enlaces.forEach(function (a) {
        a.classList.toggle('opf-activa', a.getAttribute('data-opf-catnav-link') === id);
      });
    }

    enlaces.forEach(function (a) {
      a.addEventListener('click', function (e) {
        var destino = document.getElementById(a.getAttribute('data-opf-catnav-link'));
        if (!destino) return;
        e.preventDefault();
        destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
        history.replaceState(null, '', '#' + a.getAttribute('data-opf-catnav-link'));
      });
    });

    var actual = null;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            actual = entry.target.id;
          }
        });
        if (actual) activar(actual);
      },
      { rootMargin: '-45% 0px -45% 0px', threshold: 0 }
    );
    secciones.forEach(function (s) { observer.observe(s); });
    activar(secciones[0].id);
  }
}
